import { Spinner } from '@components/ui/Spinner/Spinner';

export function Loading() {
  return (
    <div className="flex items-center justify-center">
      <Spinner />
    </div>
  );
}
